<template>
  <div class="col-md-3">
    <!-- Dataset Card -->
    <div class="card mb-4 box-shadow">
      <!-- Display Image -->
      <div class="image-container" style="position: relative;">
        <img
          v-show="!isLoading"
          @click="onImageClick"
          :src="imageUrl"
          class="card-img-top"
          @error="handleImageError"
          @load="handleImageLoad"
          style="width: 100%; display: block;"
        />
        <div v-show="isLoading" class="placeholder-image">
          <i class="fas fa-image"></i>
        </div>
      </div>

      <!-- Card Body -->
      <div class="card-body">
        <span
          class="d-inline-block text-truncate clickable"
          style="max-width: 70%; float: left"
          @click="onImageClick"
        >
          <strong class="card-title">{{ dataset.institution_name || dataset.name }}</strong>
        </span>
        <span
          v-if="dataset.exam_type"
          class="badge ml-1"
          :class="dataset.exam_type === 'screening' ? 'badge-primary' : 'badge-warning'"
          style="float: left; margin-top: 2px;"
        >
          {{ dataset.exam_type === 'screening' ? '검진' : '비급여' }}
        </span>

        <i
          class="card-text fa fa-ellipsis-v fa-x icon-more"
          :id="'dropdownDataset' + dataset.id"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          aria-hidden="true"
        />

        <br />

        <!-- <div>
          <div v-if="dataset.numberImages > 0">
            {{ dataset.numberAnnotated }} of {{ dataset.numberImages }} images
            annotated.
            <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"
                :style="{ width: percent + '%' }"
              ></div>
            </div>
          </div>

          <p v-else>No images in dataset.</p>
          <span
            v-for="(category, index) in listCategories"
            :key="index"
            class="badge badge-pill badge-primary category-badge"
            :style="{ 'background-color': category.color }"
          >
            {{ category.name }}
          </span>
        </div> -->

        <div
          class="dropdown-menu"
          :aria-labelledby="'dropdownDataset' + dataset.id"
        >
          <!-- <button
            class="dropdown-item"
            data-toggle="modal"
            :data-target="'#datasetEdit' + dataset.id"
          >
            Edit
          </button> -->
          <button
            v-if="dataset.permissions.owner"
            class="dropdown-item"
            data-toggle="modal"
            :data-target="'#datasetShare' + dataset.id"
          >
            Share
          </button>
          <!-- <button
            class="dropdown-item"
            @click="onCocoDownloadClick"
            v-show="dataset.permissions.download"
          >
            Download COCO
          </button> -->
          <hr v-show="dataset.permissions.delete" />
          <button
            class="dropdown-item delete"
            v-show="dataset.permissions.delete"
            @click="onDeleteClick"
          >
            Delete
          </button>
        </div>
      </div>

      <!-- <div
        v-show="$store.getters['user/loginEnabled']"
        class="card-footer text-muted"
      >
        Created by {{ dataset.owner }}
      </div> -->
    </div>

    <!-- Edit Dataset -->
    <div class="modal fade" role="dialog" :id="'datasetEdit' + dataset.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ dataset.institution_name || dataset.name }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <Metadata
                :metadata="defaultMetadata"
                title="Default Annotation Metadata"
                key-name="Default Key"
                value-name="Default Value"
                ref="defaultAnnotation"
              />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success"
              @click="onSave"
              data-dismiss="modal"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Share Dataset -->
    <div class="modal fade" role="dialog" :id="'datasetShare' + dataset.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ dataset.institution_name || dataset.name }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label>Users shared with</label>
                <TagsInput
                  v-model="sharedUsers"
                  element-id="usersList"
                  :existing-tags="users"
                  :typeahead="true"
                  :typeahead-activation-threshold="0"
                  placeholder="Add usernames"
                />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success"
              @click="onShare"
              data-dismiss="modal"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import axios from '@/libs/axios'
import Metadata from "@/components/Metadata";

import TagsInput from "@/components/TagsInput";

import { mapMutations } from "vuex";

export default {
  name: "DatasetCard",
  components: { Metadata, TagsInput },
  props: {
    dataset: {
      type: Object,
      required: true
    },
    // categories: {
    //   type: Array,
    //   required: false
    // }
  },
  data() {
    return {
      imageError: false,
      isLoading: true,
      defaultMetadata: this.dataset.default_annotation_metadata,
      noImageUrl: require("@/assets/no-image.png"),
      notFoundImageUrl: require("@/assets/404-image.png"),
      sharedUsers: []
    };
  },
  methods: {
    ...mapMutations(["addProcess", "removeProcess"]),
    handleImageError() {
      this.imageError = true;
      this.isLoading = false;
    },
    handleImageLoad() {
      this.isLoading = false;
    },
    onImageClick() {
      let identifier = this.dataset.id;
      this.$router.push({ name: "tabulardataset", params: { identifier } });
    },
    onShare() {
      this.dataset.users = this.sharedUsers;
      axios
        .post("/api/dataset/" + this.dataset.id + "/share", {
          users: this.sharedUsers
        })
        .then(() => {
          this.$parent.updatePage();
        });
    },
    // onCocoDownloadClick() {
    //   let process = "Generating COCO for " + this.dataset.name;
    //   this.addProcess(process);

    //   axios
    //     .get("/api/dataset/" + this.dataset.id + "/coco")
    //     .then(reponse => {
    //       let dataStr =
    //         "data:text/json;charset=utf-8," +
    //         encodeURIComponent(JSON.stringify(reponse.data));

    //       this.downloadURI(dataStr, this.dataset.name + ".json");
    //     })
    //     .finally(() => this.removeProcess(process));
    // },
    onDeleteClick() {
      axios.delete("/api/dataset/" + this.dataset.id).then(() => {
        this.$parent.updatePage();
      });
    },
    onSave() {
      this.dataset.categories = this.selectedCategories;

      axios
        .post("/api/dataset/" + this.dataset.id, {
          categories: this.selectedCategories,
          default_annotation_metadata: this.$refs.defaultAnnotation.export()
        })
        .then(() => {
          this.$parent.updatePage();
        });
    },
    // downloadURI(uri, exportName) {
    //   let link = document.createElement("a");
    //   link.href = uri;
    //   link.download = exportName;
    //   document.body.appendChild(link);
    //   link.click();
    //   link.remove();
    // },
    // createSelectedCategories() {
    //   let tagValues = Array.from([]);
    //   this.listCategories.forEach(category => {
    //     tagValues.push(category.name);
    //   });
    //   this.selectedCategories = tagValues;
    // },
    createSelectedUsers() {
      this.sharedUsers = this.dataset.users;
    }
  },
  computed: {
    // percent() {
    //   return 100 * (this.dataset.numberAnnotated / this.dataset.numberImages);
    // },
    imageUrl() {
      if (this.imageError) {
        return this.notFoundImageUrl;
      }
      if (this.dataset.numberImages > 0) {
        return "/api/image/" + this.dataset.first_image_id + "?width=250&thumbnail=true";
      }

      return this.noImageUrl;
    },
    // listCategories() {
    //   let list = [];
    //   if (!this.dataset.hasOwnProperty("categories")) return [];
    //   if (this.dataset.categories.length === 0) return [];

    //   this.dataset.categories.forEach(category => {
    //     let elements = this.categories.filter(
    //       element => element.id === category
    //     );

    //     if (elements.length === 1) {
    //       list.push(elements[0]);
    //     }
    //   });

    //   return list;
    // },
    users() {
      let users = {};
      this.$parent.users.forEach(user => {
        users[user.username] = user.username;
      });

      return users;
    }
  },
  watch: {
    imageUrl: {
      handler() {
        this.isLoading = true;
        this.imageError = false;
      },
      immediate: true
    }
  },
  mounted() {
    // this.createSelectedCategories();
    this.createSelectedUsers();
  }
};
</script>

<style scoped>
.card {
  transition: all 0.3s ease;
}

.card:hover .card-img-top {
  transform: scale(1.05);
  filter: brightness(1.1);
}

.image-container {
  width: 100%;
  height: 200px;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.image-container:hover {
  background-color: #e9ecef;
}

.placeholder-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dee2e6;
  font-size: 2.5rem;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
}

.card-img-top {
  object-fit: cover;
  height: 200px;
  width: 100%;
  display: block;
  transition: all 0.3s ease;
  filter: brightness(0.85);
}

.card-img-overlay {
  padding: 0 10px 0 0;
}

.card-body {
  padding: 10px 10px 0 10px;
}

p {
  margin: 0;
  padding: 0 0 3px 0;
}

.category-badge {
  float: left;
  margin: 0 2px 5px 0;
}

.list-group-item {
  height: 21px;
  font-size: 13px;
  padding: 2px;
  background-color: #4b5162;
}
.icon-more {
  width: 10%;
  margin: 3px 0;
  padding: 0;
  float: right;
  color: black;
}

.progress {
  margin: 0 5px 7px 5px;
  height: 5px;
}
.card-footer {
  padding: 2px;
  font-size: 11px;
}

.delete {
  color: darkred;
}

.clickable {
  cursor: pointer;
  transition: color 0.2s ease;
}

.clickable:hover {
  color: #007bff;
}
</style>
